import React from 'react';
import { Link } from 'react-router-dom';

const TermsAndConditions = () => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const sections = [
    {
      title: "1. Acceptance of Terms",
      content: "By accessing and using BuiltFutureLife (the 'Platform'), you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, you must not use our services. These terms constitute a legally binding agreement between you and BuiltFutureLife."
    },
    {
      title: "2. Eligibility",
      content: "You must be at least 18 years old to use our services. By using the Platform, you represent and warrant that you have the legal capacity to enter into this agreement. You agree to provide accurate, current, and complete information during registration and to update such information to keep it accurate, current, and complete."
    },
    {
      title: "3. Investment Plans and Returns",
      content: "All investment plans available on our platform are subject to the terms specified for each plan. Returns are calculated based on the plan parameters and are paid according to the schedule (hourly/daily). Past performance does not guarantee future results. We reserve the right to modify, suspend, or terminate any investment plan at our sole discretion with reasonable notice."
    },
    {
      title: "4. Deposits and Withdrawals",
      content: "All deposits are processed through our payment partners. Minimum and maximum deposit amounts may apply depending on the selected plan. Withdrawal requests are processed within 2-5 business days, subject to our anti-fraud checks. We reserve the right to hold withdrawals for up to 30 days for security verification. All fees associated with deposits and withdrawals are your responsibility."
    },
    {
      title: "5. Technical Maintenance",
      content: "From time to time, the Platform may experience technical issues or undergo scheduled maintenance. During such periods, payments may be delayed. We will make reasonable efforts to notify users in advance of scheduled maintenance and to minimize disruption to our services."
    },
    {
      title: "6. Account Security",
      content: "You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account or any other breach of security. We are not liable for any loss or damage arising from your failure to comply with this section."
    },
    {
      title: "7. Prohibited Activities",
      content: "You agree not to: (a) use the Platform for any illegal purpose; (b) attempt to gain unauthorized access to any part of the Platform; (c) interfere with or disrupt the integrity or performance of the Platform; (d) create multiple accounts for fraudulent purposes; (e) engage in any activity that could damage, disable, overburden, or impair our servers; (f) use bots, crawlers, or other automated systems to access the Platform."
    },
    {
      title: "8. ⚠️ FRAUD PREVENTION & PENALTY POLICY",
      content: "Any fraudulent activity on our platform will result in immediate and severe penalties. The following actions are strictly prohibited and will lead to account termination and financial penalties:"
    },
    {
      title: "8.1 Deposit Fraud & False Transactions",
      content: "If a user makes a deposit, then attempts to reinvest earnings or withdraw funds without actually adding new real funds (including but not limited to: exploiting system errors, fake payment proofs, chargeback fraud, using stolen payment methods, or attempting to reinvest the same funds repeatedly without legitimate new deposits), this constitutes severe fraud. Consequences: (a) Immediate permanent account ban without appeal; (b) 50% penalty fee applied to all funds in the account - this means 50% of your total balance will be confiscated as a penalty; (c) The remaining 50% may be held for up to 90 days for investigation; (d) Your IP address and device information will be blacklisted; (e) Legal action may be pursued for recovery of fraudulent gains."
    },
    {
      title: "8.2 Multiple Account Abuse",
      content: "Creating multiple accounts to abuse referral bonuses, deposit bonuses, or any promotional offers is strictly forbidden. Penalties include: (a) All linked accounts will be permanently banned; (b) 50% penalty fee applied to all balances across all linked accounts; (c) All referral commissions earned fraudulently will be confiscated; (d) Legal action may be taken for repeated offenses."
    },
    {
      title: "8.3 Chargeback & Payment Reversal Fraud",
      content: "Any user who initiates a chargeback, payment reversal, or dispute with their payment provider after receiving services or earnings from our platform will face: (a) Immediate account termination; (b) 50% penalty fee on all funds; (c) Outstanding balance sent to collections; (d) Permanent ban from all future services; (e) Legal action to recover damages including legal fees."
    },
    {
      title: "8.4 Exploitation & System Abuse",
      content: "Attempting to exploit bugs, glitches, or vulnerabilities in our system to gain unfair advantages (including trying to reinvest without sufficient balance, duplicating transactions, or manipulating earnings) results in: (a) Immediate account ban; (b) 50% penalty on all funds; (c) Confiscation of all fraudulently obtained earnings; (d) Permanent blacklisting; (e) Potential legal prosecution under computer fraud laws."
    },
    {
      title: "9. Risk Disclosure",
      content: "Investing in digital assets and investment plans involves substantial risk of loss and is not suitable for all investors. You should carefully consider your investment objectives, level of experience, and risk appetite. You acknowledge that you may lose some or all of your investment and that we do not guarantee any returns."
    },
    {
      title: "10. Anti-Money Laundering (AML) Policy",
      content: "We comply with all applicable anti-money laundering laws and regulations. We reserve the right to request identification documents and proof of funds at any time. Transactions suspected of being linked to money laundering, terrorist financing, or other illegal activities will be reported to the relevant authorities and your account may be suspended. A 50% penalty may be applied to suspicious accounts pending investigation."
    },
    {
      title: "11. Referral Program",
      content: "Referral bonuses are subject to the terms of our referral program. You may not refer yourself or create fake accounts to earn referral commissions. We reserve the right to revoke referral earnings obtained through fraudulent means and to terminate the offending accounts with a 50% penalty on all associated balances."
    },
    {
      title: "12. Intellectual Property",
      content: "All content, trademarks, logos, and other intellectual property displayed on the Platform are owned by or licensed to BuiltFutureLife. You agree not to copy, modify, reproduce, republish, distribute, or create derivative works of any content without our prior written consent."
    },
    {
      title: "13. Limitation of Liability",
      content: "To the maximum extent permitted by law, BuiltFutureLife and its affiliates, officers, directors, employees, and agents shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation loss of profits, data, use, goodwill, or other intangible losses resulting from your use of or inability to use the Platform."
    },
    {
      title: "14. Disclaimer of Warranties",
      content: "The Platform is provided 'as is' and 'as available' without any warranties of any kind, either express or implied. We do not warrant that the Platform will be uninterrupted, error-free, secure, or free from viruses or other harmful components. Your use of the Platform is at your sole risk."
    },
    {
      title: "15. Amendments",
      content: "We reserve the right to modify these Terms and Conditions at any time. We will notify users of material changes via email or through a notice on our Platform. Your continued use of the Platform after any such changes constitutes your acceptance of the new terms."
    },
    {
      title: "16. Termination",
      content: "We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach these Terms and Conditions. Upon termination, your right to use the Platform will cease immediately. A 50% penalty fee may be applied upon termination for violations."
    },
    {
      title: "18. Contact Information",
      content: "If you have any questions about these Terms and Conditions, please contact us at support@builtfuturelife.com or through our contact page."
    }
  ];

  return (
    <div style={{
      padding: '20px',
      maxWidth: '1000px',
      margin: '0 auto',
      paddingBottom: isMobile ? '80px' : '40px',
      backgroundColor: '#0a0a0a',
      minHeight: '100vh'
    }}>
      {/* Header */}
      <div style={{
        background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
        borderRadius: '20px',
        padding: '24px',
        marginBottom: '24px',
        border: '1px solid rgba(0, 212, 255, 0.3)'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          marginBottom: '16px'
        }}>
          <Link to="/" style={{
            background: 'rgba(0, 212, 255, 0.2)',
            borderRadius: '10px',
            padding: '10px 16px',
            textDecoration: 'none',
            color: '#00d4ff',
            fontSize: '14px',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            border: '1px solid rgba(0, 212, 255, 0.3)',
            transition: 'all 0.2s'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'rgba(0, 212, 255, 0.3)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'rgba(0, 212, 255, 0.2)';
          }}>
            <span>←</span> Back to Dashboard
          </Link>
        </div>
        
        <h1 style={{
          fontSize: '32px',
          fontWeight: '700',
          margin: '0 0 8px 0',
          background: 'linear-gradient(135deg, #fff, #00d4ff)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>
          Terms and Conditions
        </h1>
        
      </div>

      {/* ⚠️ FRAUD WARNING BANNER */}
      <div style={{
        background: 'linear-gradient(135deg, #ff4444, #cc0000)',
        borderRadius: '16px',
        padding: '20px',
        marginBottom: '24px',
        border: '1px solid #ff8888',
        animation: 'pulse 2s infinite'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          flexWrap: 'wrap'
        }}>
          <span style={{
            fontSize: '48px'
          }}>⚠️</span>
          <div style={{ flex: 1 }}>
            <h3 style={{
              color: '#fff',
              fontSize: '20px',
              margin: '0 0 8px 0',
              fontWeight: 'bold'
            }}>
              FRAUD WARNING - 50% PENALTY POLICY
            </h3>
            <p style={{
              color: '#fff',
              margin: 0,
              fontSize: '14px',
              opacity: '0.95'
            }}>
              Any attempt to reinvest without adding new funds, chargeback fraud, or system exploitation will result in 
              <strong style={{ color: '#ffcccc' }}> IMMEDIATE ACCOUNT BAN + 50% PENALTY</strong> on all funds.
            </p>
          </div>
        </div>
      </div>

      {/* Summary Card */}
      <div style={{
        background: 'linear-gradient(135deg, rgba(255, 68, 68, 0.1), rgba(255, 68, 68, 0.05))',
        borderRadius: '16px',
        padding: '20px',
        marginBottom: '24px',
        border: '1px solid rgba(255, 68, 68, 0.3)'
      }}>
        <h3 style={{
          color: '#ff6666',
          fontSize: '16px',
          margin: '0 0 12px 0',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <span>🚨</span> CRITICAL: Read Before Using
        </h3>
        <p style={{
          color: '#cbd5e1',
          fontSize: '14px',
          lineHeight: '1.6',
          margin: 0
        }}>
          By using BuiltFutureLife, you agree that if you make one deposit and then repeatedly reinvest your earnings 
          without adding new real funds, or commit any form of fraud, your account will be permanently banned and 
          <strong style={{ color: '#ff6666' }}> 50% of all your funds will be taken as a penalty</strong>. This includes chargebacks, 
          fake payments, system exploitation, and multiple account abuse.
        </p>
      </div>

      {/* Terms Sections */}
      <div style={{
        background: '#1a1a2e',
        borderRadius: '20px',
        border: '1px solid rgba(0, 212, 255, 0.2)',
        overflow: 'hidden'
      }}>
        {sections.map((section, index) => {
          const isFraudSection = section.title.includes("FRAUD") || section.title.includes("Penalty");
          return (
            <div 
              key={index}
              style={{
                padding: '24px',
                borderBottom: index < sections.length - 1 ? '1px solid rgba(0, 212, 255, 0.1)' : 'none',
                transition: 'background 0.2s',
                background: isFraudSection ? 'rgba(255, 68, 68, 0.05)' : 'transparent',
                borderLeft: isFraudSection ? '4px solid #ff4444' : 'none'
              }}
              onMouseEnter={(e) => {
                if (!isFraudSection) {
                  e.currentTarget.style.background = 'rgba(0, 212, 255, 0.03)';
                }
              }}
              onMouseLeave={(e) => {
                if (!isFraudSection) {
                  e.currentTarget.style.background = 'transparent';
                }
              }}
            >
              <h3 style={{
                color: isFraudSection ? '#ff6666' : '#00d4ff',
                fontSize: '18px',
                fontWeight: '600',
                margin: '0 0 12px 0'
              }}>
                {section.title}
              </h3>
              <p style={{
                color: '#cbd5e1',
                fontSize: '14px',
                lineHeight: '1.7',
                margin: 0
              }}>
                {section.content}
              </p>
            </div>
          );
        })}
      </div>

      {/* Penalty Summary Table */}
      <div style={{
        marginTop: '24px',
        background: '#1a1a2e',
        borderRadius: '16px',
        padding: '20px',
        border: '1px solid rgba(255, 68, 68, 0.3)'
      }}>
        <h3 style={{
          color: '#ff6666',
          fontSize: '18px',
          margin: '0 0 16px 0',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <span>📋</span> Penalty Summary Table
        </h3>
        <div style={{
          overflowX: 'auto'
        }}>
          <table style={{
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '13px'
          }}>
            <thead>
              <tr>
                <th style={{
                  textAlign: 'left',
                  padding: '12px',
                  background: 'rgba(255, 68, 68, 0.1)',
                  color: '#ff8888',
                  borderBottom: '1px solid rgba(255, 68, 68, 0.3)'
                }}>Violation Type</th>
                <th style={{
                  textAlign: 'left',
                  padding: '12px',
                  background: 'rgba(255, 68, 68, 0.1)',
                  color: '#ff8888',
                  borderBottom: '1px solid rgba(255, 68, 68, 0.3)'
                }}>Penalty</th>
                <th style={{
                  textAlign: 'left',
                  padding: '12px',
                  background: 'rgba(255, 68, 68, 0.1)',
                  color: '#ff8888',
                  borderBottom: '1px solid rgba(255, 68, 68, 0.3)'
                }}>Account Status</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                <td style={{ padding: '12px', color: '#cbd5e1' }}>Reinvesting without new deposits</td>
                <td style={{ padding: '12px', color: '#ff6666', fontWeight: 'bold' }}>50% Penalty</td>
                <td style={{ padding: '12px', color: '#ff6666' }}>Permanent Ban</td>
              </tr>
              <tr style={{ borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                <td style={{ padding: '12px', color: '#cbd5e1' }}>Chargeback / Payment Reversal</td>
                <td style={{ padding: '12px', color: '#ff6666', fontWeight: 'bold' }}>50% Penalty + Legal Action</td>
                <td style={{ padding: '12px', color: '#ff6666' }}>Permanent Ban</td>
              </tr>
              <tr style={{ borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                <td style={{ padding: '12px', color: '#cbd5e1' }}>Multiple Account Abuse</td>
                <td style={{ padding: '12px', color: '#ff6666', fontWeight: 'bold' }}>50% Penalty on ALL accounts</td>
                <td style={{ padding: '12px', color: '#ff6666' }}>All Linked Banned</td>
              </tr>
              <tr style={{ borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                <td style={{ padding: '12px', color: '#cbd5e1' }}>System Exploitation / Bugs</td>
                <td style={{ padding: '12px', color: '#ff6666', fontWeight: 'bold' }}>50% Penalty + Confiscation</td>
                <td style={{ padding: '12px', color: '#ff6666' }}>Permanent Ban</td>
              </tr>
              <tr>
                <td style={{ padding: '12px', color: '#cbd5e1' }}>Fake Payment Proofs</td>
                <td style={{ padding: '12px', color: '#ff6666', fontWeight: 'bold' }}>50% Penalty</td>
                <td style={{ padding: '12px', color: '#ff6666' }}>Permanent Ban</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Acceptance Footer */}
      <div style={{
        marginTop: '24px',
        background: '#1a1a2e',
        borderRadius: '16px',
        padding: '20px',
        border: '1px solid rgba(0, 212, 255, 0.2)',
        textAlign: 'center'
      }}>
        <p style={{
          color: '#94a3b8',
          fontSize: '13px',
          margin: '0 0 16px 0'
        }}>
          By continuing to use BuiltFutureLife, you acknowledge that you have read, understood,
          and agree to be bound by these Terms and Conditions including the <strong style={{ color: '#ff6666' }}>50% Penalty Policy for Fraud</strong>.
        </p>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '16px',
          flexWrap: 'wrap'
        }}>
          <Link to="/" style={{
            background: 'linear-gradient(135deg, #00d4ff, #0099cc)',
            color: '#fff',
            padding: '10px 24px',
            borderRadius: '30px',
            textDecoration: 'none',
            fontSize: '14px',
            fontWeight: '500',
            transition: 'all 0.2s'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 212, 255, 0.3)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
          }}>
            I Agree - Go to Dashboard
          </Link>
          <Link to="/contact" style={{
            background: 'transparent',
            color: '#00d4ff',
            padding: '10px 24px',
            borderRadius: '30px',
            textDecoration: 'none',
            fontSize: '14px',
            fontWeight: '500',
            border: '1px solid rgba(0, 212, 255, 0.5)',
            transition: 'all 0.2s'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'rgba(0, 212, 255, 0.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'transparent';
          }}>
            Contact Support
          </Link>
        </div>
      </div>

      {/* Additional Links */}
      <div style={{
        marginTop: '20px',
        display: 'flex',
        justifyContent: 'center',
        gap: '24px',
        flexWrap: 'wrap',
        padding: '16px',
        fontSize: '12px'
      }}>
        <Link to="/" style={{ color: '#64748b', textDecoration: 'none' }}>© 2025 BuiltFutureLife</Link>
        <Link to="/contact" style={{ color: '#64748b', textDecoration: 'none' }}>Contact Us</Link>
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.9; }
        }
      `}</style>
    </div>
  );
};

export default TermsAndConditions;